const ChatFlowEnableFlag = {
    Disabled: 0,
    Auto_Send: 1,
    Suggest_Agent: 2
};
export default ChatFlowEnableFlag;
